/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const config = {};

config.adobe_analytics = true;
config.cookie_first = null;
config.hotjar = null;

export default config;
